import { GetFragmentDto } from '@app/modules/fragments/fragment.types';
import { webApi } from '@mi-front/api-clients';

const EMPTY_ASSETS = {
  audio: {},
  video: {},
  thumbnails: {},
  poster: {},
} as GetFragmentDto['assets'];

/**
 * Builds a GetFragmentDto-shaped object so platform PublishForm components (which expect `fragment`)
 * can run in composition social-export flow. Only fields read by those forms are meaningful.
 */
export function compositionToSocialExportFragmentStub(
  composition: webApi.EnrichedCompositionDetailDto,
): GetFragmentDto {
  const stationId = composition.stationId ?? '';

  return {
    id: composition.id,
    createdAt: composition.createdAt,
    updatedAt: composition.updatedAt,
    clientId: composition.clientId,
    stationId,
    title: composition.name,
    description: '',
    type: 'COMPOSITION',
    from: composition.createdAt,
    to: composition.updatedAt,
    chunks: [],
    publishedPlatforms: [],
    tags: [],
    externalDeliveryStartedAt: null,
    contentAiCreatedAt: null,
    mediaCompletedAt: null,
    isMediaGenerationStalled: false,
    assets: EMPTY_ASSETS,
  } as GetFragmentDto;
}
